// REL_1.1.15 F-262 §3 + Corrigendum 2 §1.2 — Country detection (hardcoded US for current phase).
// Per Corrigendum 2 (2026-05-27 user-direct): country is hardcoded "US" until new requirements
// land. CF-IPCountry / MaxMind GeoLite2 / Front Door custom rule = REL_1.3+ scope.
//
// This module is the SINGLE PLACE that codifies the hardcoded value. When sub-feature 2
// reactivates in REL_1.3+, swap the `detectCountry()` implementation here without touching
// callers.
import type { CurrencyCode } from "./currency";

// REL_1.1.15D E-120 (Q1 ruling 2026-06-16): North-America-only → AU removed (Australia is not NA;
// signup is +1-only US/CA, so AU could never onboard). Reversible — re-add the "AU" member + the row.
// REL_1.1.15E F-313 (S-1228, operator-direct 2026-07-09): US-primary marketing → CA HIDDEN on the
// marketing site. MARKETING-ONLY — backend signup still accepts +1 (US + Canada); this is visibility,
// not a product/region change. Reversible — re-add the "CA" union member + the row (+ CAD in currency.ts).
export type CountryCode = "US"; // was "US" | "CA" — CA hidden per F-313 (reversible)

export const SUPPORTED_COUNTRIES: ReadonlyArray<{
  code: CountryCode;
  label: string;
  flag: string;
  defaultCurrency: CurrencyCode;
}> = [
  { code: "US", label: "United States",  flag: "🇺🇸", defaultCurrency: "USD" },
  // REL_1.1.15E F-313 hide-Canada (reversible): { code: "CA", label: "Canada", flag: "🇨🇦", defaultCurrency: "CAD" },
] as const;

/** Default country per Corrigendum 2 §1.2 — HARDCODED. Single replacement site for REL_1.3+. */
export const DETECTED_COUNTRY: CountryCode = "US";

/**
 * Returns the build-time-detected country. Currently a constant per Corrigendum 2; will be
 * upgraded to real CF-IPCountry / GeoIP-based detection in REL_1.3+ when country auto-detect
 * sub-feature 2 reactivates.
 */
export function detectCountry(): CountryCode {
  return DETECTED_COUNTRY;
}

/** Map a country to its default display currency. */
export function defaultCurrencyForCountry(country: CountryCode): CurrencyCode {
  const meta = SUPPORTED_COUNTRIES.find((c) => c.code === country);
  return meta?.defaultCurrency ?? "USD";
}
